<template>
	<div class="size-chooser">
		<div class="size-chooser__group">
			<input type="number" class="form-control form-control-sm size-chooser__value" v-model="val" />
			<select class="form-select form-select-sm size-chooser__metric" v-model="metric">
				<option value="px">px</option>
				<option value="%">%</option>
				<option value="em">em</option>
				<option value="rem">rem</option>
			</select>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SizeChooser',
	props: ['data'],
	data() {
		return {
			metric: 'px',
			val: '',
			imp: false,
			full: '',
		}
	},
	computed: {},
	watch: {
		'data.value': function() {
			this.$emit('change')
		},
		metric: function() {
			this.full = this.val + this.metric
			if (this.imp) {
				this.full = this.full + '!important'
			} else if (this.full) {
				this.full = this.full.replace('!important', '')
			}
			if (this.val !== '') {
				this.data.value = this.full
			} else {
				this.data.value = ''
			}
		},
		val: function() {
			this.full = this.val + this.metric
			if (this.imp) {
				this.full = this.full + '!important'
			} else if (this.full) {
				this.full = this.full.replace('!important', '')
			}
			if (this.val !== '') {
				this.data.value = this.full
			} else {
				this.data.value = ''
			}
		},
		imp: function() {
			this.full = this.val + this.metric
			if (this.imp) {
				this.full = this.full + '!important'
			} else if (this.full) {
				this.full = this.full.replace('!important', '')
			}
			if (this.val !== '') {
				this.data.value = this.full
			} else {
				this.data.value = ''
			}
		},
	},
	created() {
		this.getData()
	},
	methods: {
		getData() {
			if (this.data) {
				if (this.data.value && this.data.value.includes('!important')) {
					this.imp = true
					this.val = this.data.value.replace('!important', '')
				} else if (this.data.value) {
					this.imp = false
					this.val = this.data.value.replace('!important', '')
				}

				if (this.val) {
					
					this.val = this.val.replace('!important', '')
	
					if (this.val.includes('rem')) {
						this.metric = 'rem'
						this.val = this.val.replace('rem', '')
					} else if (this.val.includes('em')) {
						this.metric = 'em'
						this.val = this.val.replace('em', '')
					} else if (this.val.includes('%')) {
						this.metric = '%'
						this.val = this.val.replace('%', '')
					} else if (this.val.includes('px')) {
						this.metric = 'px'
						this.val = this.val.replace('px', '')
					}
				}
			}
		},
	},
	emits: ['change'],
}
</script>
<style scoped>
.size-chooser {
	width: 100%;
}

.size-chooser__group {
	display: grid;
	grid-template-columns: minmax(0, 1fr) 86px;
	gap: 0;
	align-items: stretch;
	border: 1px solid #cbd5e1;
	border-radius: 10px;
	background: #ffffff;
	overflow: hidden;
}

.size-chooser__value,
.size-chooser__metric {
	height: 34px;
	border: 0 !important;
	border-radius: 0 !important;
	box-shadow: none !important;
}

.size-chooser__value {
	border-right: 1px solid #e2e8f0;
	background: #f2f5f8 !important;
}

.size-chooser__metric {
	background: #e6ebf0 !important;
}

.size-chooser__value:focus,
.size-chooser__metric:focus {
	border: 0 !important;
	border-radius: 0 !important;
	box-shadow: none !important;
	background: inherit;
}
</style>
